
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'feedback-public-submission-ui',
  currentProjectVersion: 'static-1.30080',
  depVersions: {
  "feedback-public-submission-ui": "static-1.30080",
  "emoji-mart": "static-3.4",
  "feedback-schema": "static-1.54235",
  "head-dlb": "static-1.4921",
  "hs-test-utils": "static-1.7903",
  "hubspot-dlb": "static-2.1828",
  "HubStyleTokens": "static-2.11342",
  "I18n": "static-7.1598",
  "quartz": "static-1.6856",
  "quartz-config": "static-1.634",
  "quartz-core": "static-1.6075",
  "react-dlb": "static-1.76",
  "react-dnd": "static-4.51",
  "react-dnd-html5-backend": "static-2.10",
  "redux-mock-store": "static-1.8",
  "redux-thunk": "static-2.43",
  "sinon": "static-1.9",
  "tinymce": "static-6.5",
  "cssUtils": "static-1.764",
  "enviro": "static-4.425",
  "feedback-shared-ui": "static-1.54222",
  "feedback-utils": "static-1.54226",
  "forms-embed-utils-lib": "static-1.4354",
  "forms-utils-lib": "static-1.12374",
  "foundations-assets": "static-1.4738",
  "foundations-components": "static-1.7705",
  "foundations-theming": "static-1.4304",
  "hub-http": "static-1.6110",
  "hubspot-url-utils": "static-1.4034",
  "HubStyle": "static-2.11650",
  "icons": "static-2.637",
  "immutable": "static-2.76",
  "quick-fetch": "static-1.3826",
  "raven": "static-3.5808",
  "react": "static-7.184",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.69",
  "react-rhumb": "static-1.16546",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5259",
  "react-virtualized": "static-2.97",
  "redux": "static-4.16",
  "StyleGuideUI": "static-3.485",
  "tinymce-plugins": "static-1.57163",
  "transmute": "static-2.85",
  "ui-images": "static-2.1124",
  "UIComponents": "static-3.8289",
  "hs-promise-rejection-tracking": "static-1.5473",
  "PortalIdParser": "static-2.386",
  "raven-hubspot": "static-1.6115",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "metrics-js": "static-1.9522",
  "styled-components": "static-2.87",
  "bend-plugin-trellis-migration": "static-1.3317",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3133",
  "quartz-webpack": "static-1.3080",
  "foundations-theming-specialty": "static-1.2020",
  "property-description-translator": "static-1.3746",
  "HeadJS": "static-2.732",
  "framer-motion": "static-1.70",
  "hs-test-utils-bend-plugin": "static-1.3014",
  "msw": "static-1.39",
  "testing-library": "static-1.150",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.219",
  "moment-timezone": "static-5.81",
  "jasmine": "static-4.4216",
  "jasmine-runner": "static-1.6361",
  "dispatcher": "static-1.134",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.816",
  "hubspotter-http": "static-1.4563",
  "mobile-manifest-mixins": "static-1.506",
  "module-federation": "static-1.21",
  "quartz-auth": "static-1.531",
  "quartz-head": "static-1.521",
  "quartz-i18n": "static-1.531",
  "quartz-routing": "static-1.286",
  "quartz-test": "static-1.531",
  "quartz-tracking": "static-1.235",
  "ui-fonts": "static-1.604",
  "usage-tracker-container": "static-1.7218",
  "usage-tracker-core": "static-1.7078",
  "hs-lodash": "static-4.45",
  "sassPrefix": "static-1.153",
  "conversations-skeleton-state": "static-1.7141",
  "reference-resolvers": "static-1.8058",
  "sanitize-text": "static-1.8036",
  "PatternValidationJS": "static-1.437",
  "ReduxMessenger": "static-2.10265",
  "sanitize": "static-1.4364",
  "outpost": "static-1.4087",
  "rpc-client-utils": "static-1.4535",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.3974",
  "floating-ui": "static-1.54",
  "hs-story-utils": "static-1.9321",
  "react-aria": "static-1.64",
  "tanstack-table": "static-1.53",
  "trellis-assets": "static-1.1504",
  "bend-plugin-foundations-theming": "static-1.2787",
  "foundations-theming-base": "static-1.3289",
  "stylex": "static-1.30",
  "csstype": "static-1.50",
  "ai-components-ui-library": "static-1.8659",
  "atom": "static-1.4962",
  "codemirror": "static-5.93",
  "content-assistance-lib": "static-1.7590",
  "ContentUtils": "static-1.68011",
  "data-token-picker": "static-1.16216",
  "file-manager-components": "static-1.23272",
  "FileManagerCore": "static-1.38771",
  "FileManagerLib": "static-1.38912",
  "frontend-preferences-client": "static-1.7816",
  "hub-http-contrib": "static-1.2935",
  "interframe": "static-3.4655",
  "layout-dnd-components": "static-1.12236",
  "layout-dnd-utils": "static-1.11211",
  "property-translator": "static-1.5301",
  "react-codemirror": "static-1.10515",
  "react-colorpicker": "static-2.10101",
  "reference-resolvers-lite": "static-1.7981",
  "rich-text-lib": "static-1.19645",
  "tinymce-data": "static-1.40134",
  "tinymce-themes": "static-1.56019",
  "ui-addon-emoji-picker": "static-1.9779",
  "ui-addon-sales-email": "static-1.5103",
  "ui-brand-identity-lib": "static-1.14742",
  "bender-build-tools": "static-1.3057",
  "hub-http-shared-msw-handlers": "static-1.9714",
  "hubspotter-http-shared-msw-handlers": "static-1.9712",
  "history": "static-4.47",
  "react-router-dom": "static-5.26",
  "usage-tracker-session-replay": "static-1.4914",
  "react-immutable-proptypes": "static-2.8",
  "autolinker": "static-3.11",
  "chirp-fetch": "static-1.1773",
  "chatspot-core": "static-1.20778",
  "copilot-toolkit": "static-1.10823",
  "data-fetching-client": "static-1.9567",
  "diff-match-patch": "static-1.7",
  "superstore": "static-1.4661",
  "ui-addon-video-player": "static-1.8588",
  "ui-coaching-tips": "static-1.28233",
  "usage-tracker": "static-1.7228",
  "cms-field-types": "static-1.4701",
  "content-icons-ui": "static-1.2196",
  "integrations-lib": "static-1.15759",
  "customer-data-objects": "static-1.7547",
  "apollo-dlb": "static-3.80",
  "apollo-link-hub-http": "static-2.4542",
  "apollo-stack-hubspot": "static-3.84",
  "graphql": "static-1.80",
  "immer": "static-1.33",
  "immerable": "static-1.4045",
  "ui-addon-iframeable": "static-1.8941",
  "video-components-external": "static-1.10921",
  "video-data-lib": "static-1.34579",
  "audio-components": "static-1.5753",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.29095",
  "FileManagerImages": "static-1.36423",
  "foundations-components-legacy": "static-1.730",
  "redux-toolkit": "static-1.7",
  "reselect": "static-2.16",
  "salesImages": "static-1.522",
  "ui-universal-auth": "static-1.8824",
  "urlinator": "static-1.4423",
  "video-components": "static-1.12924",
  "video-embed": "static-1.35413",
  "ts-schema": "static-1.3989",
  "ContentData": "static-1.68086",
  "layout-data-lib": "static-1.9536",
  "react-dnd-compat": "static-1.4510",
  "browser-eslint": "static-2.57",
  "batch-promise": "static-1.1443",
  "external-options-client-types": "static-1.4069",
  "fast-json-stable-stringify": "static-1.4",
  "framework-data-schema-resolvers": "static-1.6767",
  "hs-promise-utils": "static-1.5486",
  "inbound-db-properties-service-client": "static-1.3757",
  "NamespacedHubStyle": "static-2.8979",
  "growth-onboarding-confetti": "static-1.2963",
  "SharedI18nStrings": "static-1.181",
  "ui-addon-i18n": "static-1.11039",
  "amplitude-session-replay-browser": "static-1.58",
  "markdown-it": "static-1.6",
  "magpie-lib": "static-1.5485",
  "magpie-types": "static-1.4945",
  "simple-logging-lib": "static-1.2943",
  "growth-onboarding-feedback-components": "static-1.6473",
  "flux-actions": "static-1.323",
  "hubspot-apollo-client": "static-1.4770",
  "integrations-error-boundary-lib": "static-1.13174",
  "integrations-tracking-lib": "static-1.5487",
  "laboratory-lib": "static-3.7051",
  "native-integrations-shared-strings": "static-1.7678",
  "redux-observable": "static-1.11",
  "rxjs": "static-5.10",
  "ui-shepherd-react": "static-3.10039",
  "unified-auth": "static-1.338",
  "navigation-messaging": "static-1.6951",
  "content-media-composition-data-lib": "static-1.11875",
  "content-media-compositions": "static-2.15882",
  "idb-keyval": "static-1.42",
  "media-bridge-lib": "static-1.18736",
  "unified-auth-core-lib": "static-1.619",
  "social-insights-client-types": "static-1.21750",
  "advanced-menus-core": "static-1.14959",
  "advanced-menus-lib": "static-1.11922",
  "ExportDialog": "static-6.10282",
  "ui-memberships-settings-lib": "static-1.33740",
  "conditional-properties-service-client": "static-1.3708",
  "crm-pipelines-api-client-types": "static-1.4053",
  "framework-builder-read-service-client": "static-1.3919",
  "framework-data-schema-quick-fetch": "static-1.6672",
  "inbound-db-meta-service-client": "static-1.3500",
  "multi-currency-client-types": "static-1.3600",
  "persist-promise": "static-1.3600",
  "foundations-components-test-utils": "static-1.5188",
  "reactive-lib": "static-1.616",
  "hubspot-apollo-cache": "static-1.229",
  "universal-page-editor-lib": "static-1.2898",
  "js-cookie": "static-1.18",
  "fsm": "static-1.3625",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14958",
  "simple-menus-lib": "static-1.16475",
  "crm-record-cards-service-types": "static-1.3521",
  "location-customization-utils-lib": "static-1.8897",
  "react-flip-move": "static-1.68"
},
  depPathPrefixes: {
  "feedback-public-submission-ui": "/feedback-public-submission-ui/static-1.30080",
  "emoji-mart": "/emoji-mart/static-3.4",
  "feedback-schema": "/feedback-schema/static-1.54235",
  "head-dlb": "/head-dlb/static-1.4921",
  "hs-test-utils": "/hs-test-utils/static-1.7903",
  "hubspot-dlb": "/hubspot-dlb/static-2.1828",
  "HubStyleTokens": "/HubStyleTokens/static-2.11342",
  "I18n": "/I18n/static-7.1598",
  "quartz": "/quartz/static-1.6856",
  "quartz-config": "/quartz-config/static-1.634",
  "quartz-core": "/quartz-core/static-1.6075",
  "react-dlb": "/react-dlb/static-1.76",
  "react-dnd": "/react-dnd/static-4.51",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-thunk": "/redux-thunk/static-2.43",
  "sinon": "/sinon/static-1.9",
  "tinymce": "/tinymce/static-6.5",
  "cssUtils": "/cssUtils/static-1.764",
  "enviro": "/enviro/static-4.425",
  "feedback-shared-ui": "/feedback-shared-ui/static-1.54222",
  "feedback-utils": "/feedback-utils/static-1.54226",
  "forms-embed-utils-lib": "/forms-embed-utils-lib/static-1.4354",
  "forms-utils-lib": "/forms-utils-lib/static-1.12374",
  "foundations-assets": "/foundations-assets/static-1.4738",
  "foundations-components": "/foundations-components/static-1.7705",
  "foundations-theming": "/foundations-theming/static-1.4304",
  "hub-http": "/hub-http/static-1.6110",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4034",
  "HubStyle": "/HubStyle/static-2.11650",
  "icons": "/icons/static-2.637",
  "immutable": "/immutable/static-2.76",
  "quick-fetch": "/quick-fetch/static-1.3826",
  "raven": "/raven/static-3.5808",
  "react": "/react/static-7.184",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.69",
  "react-rhumb": "/react-rhumb/static-1.16546",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5259",
  "react-virtualized": "/react-virtualized/static-2.97",
  "redux": "/redux/static-4.16",
  "StyleGuideUI": "/StyleGuideUI/static-3.485",
  "tinymce-plugins": "/tinymce-plugins/static-1.57163",
  "transmute": "/transmute/static-2.85",
  "ui-images": "/ui-images/static-2.1124",
  "UIComponents": "/UIComponents/static-3.8289",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5473",
  "PortalIdParser": "/PortalIdParser/static-2.386",
  "raven-hubspot": "/raven-hubspot/static-1.6115",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "metrics-js": "/metrics-js/static-1.9522",
  "styled-components": "/styled-components/static-2.87",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3317",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3133",
  "quartz-webpack": "/quartz-webpack/static-1.3080",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2020",
  "property-description-translator": "/property-description-translator/static-1.3746",
  "HeadJS": "/HeadJS/static-2.732",
  "framer-motion": "/framer-motion/static-1.70",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3014",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.150",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.219",
  "moment-timezone": "/moment-timezone/static-5.81",
  "jasmine": "/jasmine/static-4.4216",
  "jasmine-runner": "/jasmine-runner/static-1.6361",
  "dispatcher": "/dispatcher/static-1.134",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.816",
  "hubspotter-http": "/hubspotter-http/static-1.4563",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.506",
  "module-federation": "/module-federation/static-1.21",
  "quartz-auth": "/quartz-auth/static-1.531",
  "quartz-head": "/quartz-head/static-1.521",
  "quartz-i18n": "/quartz-i18n/static-1.531",
  "quartz-routing": "/quartz-routing/static-1.286",
  "quartz-test": "/quartz-test/static-1.531",
  "quartz-tracking": "/quartz-tracking/static-1.235",
  "ui-fonts": "/ui-fonts/static-1.604",
  "usage-tracker-container": "/usage-tracker-container/static-1.7218",
  "usage-tracker-core": "/usage-tracker-core/static-1.7078",
  "hs-lodash": "/hs-lodash/static-4.45",
  "sassPrefix": "/sassPrefix/static-1.153",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7141",
  "reference-resolvers": "/reference-resolvers/static-1.8058",
  "sanitize-text": "/sanitize-text/static-1.8036",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "ReduxMessenger": "/ReduxMessenger/static-2.10265",
  "sanitize": "/sanitize/static-1.4364",
  "outpost": "/outpost/static-1.4087",
  "rpc-client-utils": "/rpc-client-utils/static-1.4535",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3974",
  "floating-ui": "/floating-ui/static-1.54",
  "hs-story-utils": "/hs-story-utils/static-1.9321",
  "react-aria": "/react-aria/static-1.64",
  "tanstack-table": "/tanstack-table/static-1.53",
  "trellis-assets": "/trellis-assets/static-1.1504",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2787",
  "foundations-theming-base": "/foundations-theming-base/static-1.3289",
  "stylex": "/stylex/static-1.30",
  "csstype": "/csstype/static-1.50",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8659",
  "atom": "/atom/static-1.4962",
  "codemirror": "/codemirror/static-5.93",
  "content-assistance-lib": "/content-assistance-lib/static-1.7590",
  "ContentUtils": "/ContentUtils/static-1.68011",
  "data-token-picker": "/data-token-picker/static-1.16216",
  "file-manager-components": "/file-manager-components/static-1.23272",
  "FileManagerCore": "/FileManagerCore/static-1.38771",
  "FileManagerLib": "/FileManagerLib/static-1.38912",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7816",
  "hub-http-contrib": "/hub-http-contrib/static-1.2935",
  "interframe": "/interframe/static-3.4655",
  "layout-dnd-components": "/layout-dnd-components/static-1.12236",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11211",
  "property-translator": "/property-translator/static-1.5301",
  "react-codemirror": "/react-codemirror/static-1.10515",
  "react-colorpicker": "/react-colorpicker/static-2.10101",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7981",
  "rich-text-lib": "/rich-text-lib/static-1.19645",
  "tinymce-data": "/tinymce-data/static-1.40134",
  "tinymce-themes": "/tinymce-themes/static-1.56019",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9779",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5103",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.14742",
  "bender-build-tools": "/bender-build-tools/static-1.3057",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9714",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9712",
  "history": "/history/static-4.47",
  "react-router-dom": "/react-router-dom/static-5.26",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4914",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "autolinker": "/autolinker/static-3.11",
  "chirp-fetch": "/chirp-fetch/static-1.1773",
  "chatspot-core": "/chatspot-core/static-1.20778",
  "copilot-toolkit": "/copilot-toolkit/static-1.10823",
  "data-fetching-client": "/data-fetching-client/static-1.9567",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "superstore": "/superstore/static-1.4661",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8588",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28233",
  "usage-tracker": "/usage-tracker/static-1.7228",
  "cms-field-types": "/cms-field-types/static-1.4701",
  "content-icons-ui": "/content-icons-ui/static-1.2196",
  "integrations-lib": "/integrations-lib/static-1.15759",
  "customer-data-objects": "/customer-data-objects/static-1.7547",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4542",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "graphql": "/graphql/static-1.80",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4045",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8941",
  "video-components-external": "/video-components-external/static-1.10921",
  "video-data-lib": "/video-data-lib/static-1.34579",
  "audio-components": "/audio-components/static-1.5753",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.29095",
  "FileManagerImages": "/FileManagerImages/static-1.36423",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.730",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "reselect": "/reselect/static-2.16",
  "salesImages": "/salesImages/static-1.522",
  "ui-universal-auth": "/ui-universal-auth/static-1.8824",
  "urlinator": "/urlinator/static-1.4423",
  "video-components": "/video-components/static-1.12924",
  "video-embed": "/video-embed/static-1.35413",
  "ts-schema": "/ts-schema/static-1.3989",
  "ContentData": "/ContentData/static-1.68086",
  "layout-data-lib": "/layout-data-lib/static-1.9536",
  "react-dnd-compat": "/react-dnd-compat/static-1.4510",
  "browser-eslint": "/browser-eslint/static-2.57",
  "batch-promise": "/batch-promise/static-1.1443",
  "external-options-client-types": "/external-options-client-types/static-1.4069",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6767",
  "hs-promise-utils": "/hs-promise-utils/static-1.5486",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3757",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8979",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2963",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.181",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11039",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.58",
  "markdown-it": "/markdown-it/static-1.6",
  "magpie-lib": "/magpie-lib/static-1.5485",
  "magpie-types": "/magpie-types/static-1.4945",
  "simple-logging-lib": "/simple-logging-lib/static-1.2943",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6473",
  "flux-actions": "/flux-actions/static-1.323",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4770",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13174",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5487",
  "laboratory-lib": "/laboratory-lib/static-3.7051",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7678",
  "redux-observable": "/redux-observable/static-1.11",
  "rxjs": "/rxjs/static-5.10",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10039",
  "unified-auth": "/unified-auth/static-1.338",
  "navigation-messaging": "/navigation-messaging/static-1.6951",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11875",
  "content-media-compositions": "/content-media-compositions/static-2.15882",
  "idb-keyval": "/idb-keyval/static-1.42",
  "media-bridge-lib": "/media-bridge-lib/static-1.18736",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.619",
  "social-insights-client-types": "/social-insights-client-types/static-1.21750",
  "advanced-menus-core": "/advanced-menus-core/static-1.14959",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11922",
  "ExportDialog": "/ExportDialog/static-6.10282",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33740",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3708",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4053",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3919",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6672",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3500",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3600",
  "persist-promise": "/persist-promise/static-1.3600",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5188",
  "reactive-lib": "/reactive-lib/static-1.616",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.229",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2898",
  "js-cookie": "/js-cookie/static-1.18",
  "fsm": "/fsm/static-1.3625",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14958",
  "simple-menus-lib": "/simple-menus-lib/static-1.16475",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3521",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8897",
  "react-flip-move": "/react-flip-move/static-1.68"
}
};
